import { useContext } from 'react';
import { NavContext } from './context/NavContext';

export function useNavItems() {
	const { addItems, removeItems } = useContext(NavContext);

	return { addItems, removeItems };
}
